export default __webpack_public_path__ + "static/media/santa-texting.46fd0c99.jpg";